import { cn } from "@/lib/cn";
import { useTranslations } from "next-intl";
import React from "react";

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const CustomInput = ({
  type = "text",
  placeholder,
  className,
  ...props
}: InputProps) => {
  const t = useTranslations();

  return (
    <input
      type={type}
      placeholder={placeholder ? t(placeholder) : t("Enter text")}
      className={cn(
        "w-full p-2 placeholder:text-sm lg:placeholder:text-lg placeholder:text-gray-400 dark:placeholder:text-gray-500 placeholder:font-medium rounded-[5px] border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30 dark:border-input dark:hover:bg-input/50  dark:focus:ring-primary/50 dark:focus:border-transparent",
        className
      )}
      {...props}
    />
  );
};

export default CustomInput;
